import { subDays, addDays } from "date-fns";

const CRMProductCategoryConfigs = {
  master: {
    title: "CRM Product Category",
    apiName: "crm/crmproductcategory",
    orderBy: "id",
    orderMethod: "ASC",
    additionalParams: { 
      // add_params
    },
  },
  dialog: {
    title: "CRM Product Category",
    isForm: false,
  },

  columns: [
    // add_configs
    {
      name: "Name",
      field: "name",
      type: "text_plain",
      table: true,
      filter: true,
      editor: true,
      object_name: "",
      object_field: "",
    },
  ],
};

export default CRMProductCategoryConfigs;
